import baseApi from '../baseApi';

export const userService = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getUsers: builder.query({
            query: () => ({
                url: `api/User/GetUserList`,
            }),
            providesTags: (result, error, userId) => [{ type: 'Users' }],
        }),
        getUserDetails: builder.query({
            query: ({ userId, userName, email, authKey }) => ({
                url: 'api/User/GetUserDetails',
                params: { userId, userName, email, authKey },
            }),
            providesTags: (result, error, args) => [{ type: 'UserDetails', id: args?.userId }],
        }),
        getUserRoles: builder.query({
            query: (isDisplay) => ({
                url: 'api/User/GetRoles',
                params: { isDisplay },
            }),
            providesTags: (result, error, userId) => [{ type: 'UserRoles' }],
        }),
        getUserRelation: builder.query({
            query: (userId) => ({
                url: 'api/User/GetUserRelation',
                params: { userId },
            }),
            providesTags: (result, error, userId) => [{ type: 'UserRelation' }],
        }),
        createUser: builder.mutation({
            query: (body) => ({
                url: 'api/User/CreateUser',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['UserDetails', 'Users'], // This will re-fetch the list automatically
        }),
        changePassword: builder.mutation({
            query: (body) => ({
                url: 'api/User/ChangePassword',
                method: 'POST',
                body,
            }),
            //invalidatesTags: ['Submitters'], // This will re-fetch the list automatically
        }),

        deleteOrDeActivateUser: builder.mutation({
            query: (body) => ({
                url: 'api/User/DeleteOrDeActivateUser',
                method: 'POST',
                body,
            }),
            //invalidatesTags: ['Submitters'], // This will re-fetch the list automatically
        }),
    }),
});

export const {
    useGetUsersQuery,
    useGetUserRolesQuery,
    useGetUserDetailsQuery,
    useLazyGetUserDetailsQuery,
    useCreateUserMutation,
    useGetUserRelationQuery,
    useChangePasswordMutation,
    useDeleteOrDeActivateUserMutation,
} = userService;
